import * as React from 'react';
import { getTruncationCss } from '../../utils';
import { EInputType, ESuggestType } from '../../../../types';
import { UndergroundLines } from '../UndergroundLines';
import { ItemContent } from '../ItemContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BaseSuggestionContent = function BaseSuggestionContent(props) {
  var item = props.item,
    inputType = props.inputType,
    itemsTruncation = props.itemsTruncation;
  var isMobile = !(inputType === EInputType.search || inputType === EInputType.mainpage);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [item.type === ESuggestType.underground && /*#__PURE__*/_jsx(UndergroundLines, {
      lines: item.lines,
      isMobile: isMobile
    }), /*#__PURE__*/_jsx("div", {
      className: getTruncationCss(itemsTruncation),
      children: /*#__PURE__*/_jsx("span", {
        className: getTruncationCss(itemsTruncation, true),
        children: /*#__PURE__*/_jsx(ItemContent, {
          item: item
        })
      })
    })]
  });
};